module.exports = __webpack_public_path__ + "static/media/list_empty.0f6462b2.png";